export default {
    filters: {
        omitTitle(value) {
            if (value.length > 18) {
                return value.slice(0, 18) + '...'
            } else {
                return value
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/newItemconent/modules/mixin.js